const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

const isEdge = ua.includes('Edg/');
const isFirefox = ua.includes('Firefox');
const isChrome = ua.includes('Chrome') && !isEdge;
const isSafari = ua.includes('Safari') && !isChrome && !isEdge;

const isWin = ua.includes('Windows');
const isMac = ua.includes('Macintosh') || ua.includes('Mac OS');

const os = isWin ? 'Win' : isMac ? 'Mac' : 'Other';
const browser = isChrome
  ? 'Chrome'
  : isEdge
    ? 'Edge'
    : isFirefox
      ? 'Firefox'
      : isSafari
        ? 'Safari'
        : 'Unknown';

/**
 * Platform key combining OS and browser, e.g. "Win+Chrome", "Mac+Safari".
 * Useful as a lookup key for platform-specific behaviour tables.
 */
export const platformKey = `${os}+${browser}`;

export {isWin, isMac, isEdge, isFirefox, isChrome, isSafari, os, browser};
